import * as _ from "lodash";
import {IHttpService, ILogService, IPromise, IQService} from "angular";
import {TeachingPeriod} from "../model/TeachingPeriod";

export class FacultyService {
    private faculties: any[];
    private facultyEnumMap;

    /* @ngInject */
    constructor(private $http: IHttpService,
                private $log: ILogService,
                private $q: IQService) {
        $log.info("FacultyService");
    }

    public getFaculties(): IPromise<any[]> {
        if (this.faculties) {
            return this.$q.resolve(this.faculties);
        }

        return this.initialise().then(() => {
            return this.faculties;
        });
    }

    public getFacultyEnumMap(): any {
        if (this.facultyEnumMap) {
            return this.$q.resolve(this.facultyEnumMap);
        }

        return this.initialise().then(() => {
            return this.facultyEnumMap;
        });
    }

    public getTeachingPeriods(): IPromise<TeachingPeriod[]> {
        return this.$http.get("/api/teaching-periods").then((resp) => {
            this.$log.debug("teaching-periods", resp.data);
            return resp.data as TeachingPeriod[];
        });
    }

    private initialise(): IPromise<void> {
        return this.fetchFaculties().then((faculties) => {
            this.faculties = faculties;
            this.facultyEnumMap = _.reduce(faculties, (facultyMap, faculty) => {
                facultyMap[faculty.name] = faculty;
                return facultyMap;
            }, {});

            this.$log.debug("FacultyDtoService.initialise()", this.faculties, this.facultyEnumMap);
        });
    }

    private fetchFaculties(): IPromise<any[]> {
        return this.$http.get("/api/faculties").then((resp) => {
            this.$log.debug("faculties", resp.data);
            return resp.data as any[];
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/faculty/faculty.service.ts